// Deathspeaker helpers. Pure. No React, no Three.js.
//
// ── Codex (Deathspeaker) ──
//   "You may banish a dead minion each turn to cast a copy of it, and
//    for (0) if you're on Death's Door. The copy enters the realm,
//    uses its Genesis, then is banished."
//
// The orchestrator (avatarAbilities) owns the cemetery picker, the
// mana payment, the click-to-place spawn, and the post-Genesis banish.
// This module owns the read-only predicates and the cost math.
//
// Catalog shape is the NORMALIZED card object (type top-level), same
// contract as the Archimago / Flamecaller helpers.
import { countsAsMinion } from '../../../core/typeline';

function lookupCatalog(card, catalog) {
  if (!card || !catalog) return null;
  return catalog.find((c) => c?.unique_id === card.cardId) || null;
}

/** True iff `card` (a cemetery cardInstance) is a Minion in the catalog. */
export function isMinionCard(card, catalog) {
  return countsAsMinion(lookupCatalog(card, catalog));
}

/** Filter a cemetery's card list down to Minions. */
export function findMinionsInCemetery(cemeteryCards, catalog) {
  return (cemeteryCards || []).filter((c) => isMinionCard(c, catalog));
}

/** True iff at least one dead Minion is available to copy. */
export function cemeteryHasMinion(cemeteryCards, catalog) {
  return (cemeteryCards || []).some((c) => isMinionCard(c, catalog));
}

/**
 * Mana cost of the copy: the minion's printed cost, or (0) when the
 * caster is on Death's Door.
 */
export function copyCastCost(card, catalog, atDeathsDoor) {
  if (atDeathsDoor) return 0;
  return Number(lookupCatalog(card, catalog)?.cost || 0);
}
